import { useNavigate } from "react-router-dom";
import AcquisitionListing from "./AcquisitionCodeMaintenanceListing"
import { useDispatch, useSelector } from "react-redux";
import { operations } from 'redux/Navigation'
import { useCallback, useEffect, useState } from "react";
import userProfileSelectors from 'redux/UserProfile/selectors'
import ConfirmationBee from "../../../../assets/images/ConfirmationBee.svg";
import SuccessBee from "../../../../assets/images/SuccessBee.svg";
import { getCreateNewCodeList, getCreateNewCodeSave, setCreateNewCodeSave } from "Store/OrderManagement/AcquisitionCode/AcquisitionCodeAction";
import { CONSTANTS } from "client/utils/constants";
import { useDebounce } from "client/CommonComponents/CustomDebounce/DebounceHook";

const AcquisitionListingContainer = () => {
  const Navigate = useNavigate();
  const dispatch = useDispatch();
  const navDispatch = operations.dispatchNav(dispatch);
  const dispatchHeaderNav = operations.dispatchHeaderNav(dispatch);

  const [paginationData, setPaginationData] = useState<any>({});
  const [sortData, setSortData] = useState<any>({});
  const [serverTotal, setServerTotal] = useState(0)
  const [pagesCount, setPagesCount] = useState<number>(0);
  const [filteredCode, setFilteredCode] = useState<any>('');
  const [filteredDescription, setFilteredDescription] = useState<any>('');
  const [showGrid, setShowGrid] = useState<any>(false);
  const initialState = {
    acquisitionCode: '',
    acquisitionCodeError: '',
    acquisitionDescription: '',
    acquisitionDescriptionError: ''
  }
  const [acquisitionValues, setAcquisitionValues] = useState<any>(initialState);
  const [Popupcontent, setPopupcontent] = useState<any>({
    title: "",
    isDialogVisible: false,
    isTitleWarning: false,
    subtextcontent: "",
    primaryBtnText: "",
    outlineBtnText: "",
    isSingleConfirmationBtn: false,
    isCommentboxVisible: false,
    isCompletedReportVisible: false,
    titleImg: "",
    isCommentBoxRequire: false,
    outlineBtnnavigateTo: "",
    primaryBtnnavigateTo: "",
    actionby: "",
    value: 0,
    comments: "",
  });

  const { userData,
    createNewCodeList,
    createNewCodeSave }: any = useSelector((state: any) => ({
      userData: userProfileSelectors.getUserDetails(state),
      createNewCodeList: state.NewAcquisitionCodeReducers.createNewCodeList,
      createNewCodeSave: state.NewAcquisitionCodeReducers.createNewCodeSave
    }))

  useEffect(() => {
    setServerTotal(createNewCodeList?.totalRecords)
    setShowGrid(true)
  }, [createNewCodeList])

  const fetchAcquisitionList = () => {
    const payload = getGridData();
    dispatch(getCreateNewCodeList(payload))
  }

  useEffect(() => {
    fetchAcquisitionList()
  }, [])

  const successBtnOnClick = () => {
    setShowGrid(false);
    fetchAcquisitionList();
    setAcquisitionValues(initialState)
    dispatch(setCreateNewCodeSave({}))
    setFilteredCode('')
    setFilteredDescription('')
    setTimeout(() => {
      setShowGrid(true);
    })
  }

  const hideDialog = useCallback(() => {
    setPopupcontent({ ...Popupcontent, isDialogVisible: false })
    if (createNewCodeSave?.hasOwnProperty('validationMessage')) {
      if (createNewCodeSave?.validationMessage == null && createNewCodeSave?.isValid) {
        successBtnOnClick()
      } else {
        dispatch(setCreateNewCodeSave({}))
      }
    }
  }, [Popupcontent])

  useEffect(() => {
    if (createNewCodeSave?.hasOwnProperty('validationMessage')) {

      if (createNewCodeSave?.validationMessage == null && createNewCodeSave?.isValid) {
        setPopupcontent({
          ...Popupcontent,
          titleImg: SuccessBee,
          title: CONSTANTS.TITLE_SUCCESS,
          isDialogVisible: true,
          isTitleWarning: false,
          subtextcontent: "Acquisition code and description added succesfully.",
          outlineBtnText: "Close",
          popupOutlinebtnOnclick: () => {
            hideDialog();
            successBtnOnClick()
          },
          isSingleConfirmationBtn: true,
          isAdditionalConfirmationBtn: false
        });

      } else {
        setPopupcontent({
          ...Popupcontent,
          titleImg: ConfirmationBee,
          title: 'INFORMATION',
          isDialogVisible: true,
          isTitleWarning: false,
          subtextcontent: createNewCodeSave?.validationMessage,
          outlineBtnText: "Ok",
          popupOutlinebtnOnclick: () => {
            hideDialog();
            dispatch(setCreateNewCodeSave({}))
          },
          isSingleConfirmationBtn: true,
          isAdditionalConfirmationBtn: false
        });
      }
    }
  }, [createNewCodeSave])

  const fetchAction = useCallback((fetchData: any) => {
    if (fetchData.action && fetchData.action === "paging") {
      setPaginationData(fetchData.data)
    }
    if (fetchData.action && fetchData.action === "sorting") {
      setSortData(fetchData.data[0]);
    }
  }, [])

  const acquisitionListingColumns = [
    {
      key: "acquisitionCode",
      title: "Code",
      filterRowValue: filteredCode?.trim()?.length ? filteredCode : ''
    },
    {
      key: "acquisitionCodeDescription",
      title: "Description",
      filterRowValue: filteredDescription?.trim()?.length ? filteredDescription : ''
    }
  ];

  const breadcrumlist = [
    { text: 'Admin Settings', key: 'f1', href: '/ordermanagement', onClick: (e: any) => { e.preventDefault(); Navigate('/ordermanagement'); navDispatch('Admin'); dispatchHeaderNav('Admin'); } },
    { text: "Acquisition Code Maintenance", key: "f2", href: '/ordermanagement', onClick: (e: any) => { e.preventDefault(); Navigate('/ordermanagement/acquisitioncodemaintenance') } },
    { text: "Create New Acquisition Code", key: "f2" }
  ]

  const handleClickBack = () => {
    Navigate('/ordermanagement/acquisitioncodemaintenance')
  }

  const validate = (name?: any, value?: any, acquisitionValuesTemp?: any) => {
    let val: any = {}
    if (name == "acquisitionCode") {
      if (value?.length == 0) {
        val = { ...acquisitionValuesTemp, acquisitionCodeError: "Code is Required." }
        setAcquisitionValues(val)
      } else if (value?.length > 20) {
        val = { ...acquisitionValuesTemp, acquisitionCodeError: "Please enter Code less than 20 characters." }
        setAcquisitionValues(val)
      } else {
        val = { ...acquisitionValuesTemp, acquisitionCodeError: "" }
        setAcquisitionValues(val)
      }
    } else {
      if (value?.length == 0) {
        val = { ...acquisitionValuesTemp, acquisitionDescriptionError: "Description is Required." }
        setAcquisitionValues(val)
      } else if (value?.length > 100) {
        val = { ...acquisitionValuesTemp, acquisitionDescriptionError: "Please enter Description less than 100 characters." }
        setAcquisitionValues(val)
      } else {
        val = { ...acquisitionValuesTemp, acquisitionDescriptionError: "" }
        setAcquisitionValues(val)
      }
    }
    return val;
  }

  const handleOnChange = (e: any) => {
    let name = e?.target?.name
    let value = e?.target?.value
    let acquisitionValuesTemp = validate(name, value, acquisitionValues)
    setAcquisitionValues({ ...acquisitionValuesTemp, [name]: value })
  }

  const handleClickAdd = () => {

    let error = JSON.parse(JSON.stringify(acquisitionValues));
    error = JSON.parse(JSON.stringify(validate("acquisitionCode", error?.acquisitionCode, error)));
    error = JSON.parse(JSON.stringify(validate("acquisitionDescription", error?.acquisitionDescription, error)));
    if (!error?.acquisitionCodeError?.trim()?.length && !error?.acquisitionDescriptionError?.trim()?.length) {
      let payload = {
        acquisitionCode: acquisitionValues?.acquisitionCode,
        acquisitionCodeDescription: acquisitionValues?.acquisitionDescription,
        savedBy: userData?.emailId
      }
      dispatch(getCreateNewCodeSave(payload))
    }

  }

  useEffect(() => {
    if (serverTotal && paginationData?.pageSize) {
      let pageSize = paginationData?.pageSize
      let tempPageCount = serverTotal > pageSize ? Math.ceil(serverTotal / pageSize - 1) : 0
      setPagesCount(tempPageCount)
    }
  }, [serverTotal, paginationData?.pageSize])

  const setFilters = (value: any) => {
    if (Object.keys(value)[0] == "acquisitionCode") {
      setFilteredCode(Object.values(value)[0] ?? '')
    } else if (Object.keys(value)[0] == "acquisitionDescription") {
      setFilteredDescription(Object.values(value)[0] ?? '')
    }
  }

  const getFilteredValues = () => {
    let filteredValues: any = [];
    if (filteredCode != "" && filteredCode) {
      filteredValues.push({ 'field': 'acquisitionCode', 'value': filteredCode })
    }
    if (filteredDescription != "" && filteredDescription) {
      filteredValues.push({ 'field': 'acquisitionDescription', 'value': filteredDescription })
    }
    return filteredValues;
  }

  const debounceObject = [
    paginationData, filteredDescription, sortData, filteredCode
  ]

  const globalDebounce = useDebounce(debounceObject, 500)

  useEffect(() => {
    const payload = getGridData();
    if (payload.pageNumber && payload.pageSize) {
      dispatch(getCreateNewCodeList(payload));
    }
  }, [globalDebounce])

  const getGridData = () => {
    let payload: any = {
      "pageNumber": paginationData?.pageIndex != undefined ? paginationData?.pageIndex + 1 : undefined,
      "pageSize": paginationData?.pageSize,
      "columnFilters": getFilteredValues()
    }

    if (sortData?.key != '') {
      payload.sortBy = sortData?.key;
      payload.sortOrder = sortData?.sortDirection;
    }
    return payload;
  }

  return (
    <AcquisitionListing
      acquisitionListingColumns={acquisitionListingColumns}
      breadcrumlist={breadcrumlist}
      handleClickBack={handleClickBack}
      createNewCodeList={createNewCodeList}
      handleOnChange={handleOnChange}
      acquisitionValues={acquisitionValues}
      handleClickAdd={handleClickAdd}
      Popupcontent={Popupcontent}
      hideDialog={hideDialog}
      fetchAction={fetchAction}
      serverTotal={serverTotal}
      pagesCount={pagesCount}
      setFilters={setFilters}
      showGrid={showGrid}
    />
  )
}

export default AcquisitionListingContainer